import { createContext } from 'react';
import { PaginationContextType } from './types';

export const PaginationContext = createContext<PaginationContextType>({
  hasNextPage: false,
  nextPageLoading: false,
  fetchNextPage: () => {},
});
